import './style/App.css'
import React, { Suspense } from 'react'
import { renderRoutes } from 'react-router-config'
import { createBrowserHistory } from 'history'
import * as Sentry from '@sentry/react'
import routes from './routes'
import { useLocation } from 'react-router-dom'
import _ from 'lodash'
import { useSetRecoilState } from 'recoil'
import { Button } from '@material-ui/core'

import { adsState } from 'global/forms'
import { BaseHeader } from 'components/base-header'
import { BaseFooter } from 'components/base-footer'
export const history = createBrowserHistory()

const useSentry = process.env.REACT_APP_USE_SENTRY
const sentrySetting = {
  dsn: process.env.REACT_APP_SENTRY_DNS,
  release: process.env.REACT_APP_VERSION,
  environment: process.env.REACT_APP_ENVIRONMENT
}

if (useSentry == 'true') Sentry.init(sentrySetting)

// Must return an element: Sentry's ErrorBoundary renders nothing for a plain string fallback.
// Answers live only in Recoil (above this boundary), so resetError keeps them, while a page refresh would lose them.
const errorFallback = ({ resetError }) => (
  <div className="wrapper">
    <p>Sorry, something went wrong. Please click Try Again to carry on with your quote.</p>
    <Button size="large" variant="contained" color="secondary" className="btn-action" onClick={resetError} style={{ textTransform: 'capitalize' }}>
      Try again
    </Button>
    <p>
      If the problem continues, call us on <a href="tel:1300650670">1300 650 670</a>.
    </p>
  </div>
)

// console.log('Using sentry: ', useSentry, sentrySetting)

const App = () => {
  const { search } = useLocation()
  const setAdsState = useSetRecoilState(adsState)

  const urlParams = new URLSearchParams(search)
  const params = Object.fromEntries(urlParams) // {abc: "foo", def: "[asf]", xyz: "5"}

  if (!_.isEmpty(params)) {
    setAdsState(params)
  }
  return (
    <>
      <BaseHeader />
      <main className="App App-header">
        <Sentry.ErrorBoundary fallback={errorFallback}>{renderRoutes(routes)}</Sentry.ErrorBoundary>
      </main>
      <BaseFooter />
    </>
  )
}

export default App
